<template>
  <div>
    <b-form-group
      :label="$t('custom_forms.maxlengthSelect')"
      label-for="maxLength"
    >
      <b-form-input
        id="maxLength"
        v-model="maxLength"
        @input="onlyInteger"
        class="w-50"
        step="1"
        type="number"
        min="1"
      />
    </b-form-group>
  </div>
</template>

<script>
import {onMounted, ref} from '@vue/composition-api';

export default {
  props: {
    data: {
      type: Object,
      default: () => ({ data: [] }),
    },
    config: Object,
  },
  setup(props, {emit, root}) {
    const maxLength = ref("")

    onMounted(async () => {
      maxLength.value = props.data?.data?.[0]?.maxLength
    });

    function onInputChange() {
      const payload = {
        maxLength: maxLength.value,
      }

      emit("update:data", {
        data: [{ ...payload }] ,
      });
    }

    function onlyInteger() {
      if(!maxLength.value) return;
      if (maxLength.value.includes('.')) {
        maxLength.value = maxLength.value.replace(/\./g, '');
      }
      if (maxLength.value.includes('-')) {
        maxLength.value = maxLength.value.replace(/-/g, '');
      }
      const num = Number(maxLength.value);
      if (!num || num <= 0) {
        maxLength.value = 1;
      }
      onInputChange()
    }

    return {
      maxLength,
      onInputChange,
      onlyInteger
    };
  },
};
</script>
